import {
  FETCH_PROFILES_REQUEST,
  FETCH_PROFILES_SUCCESS,
  FETCH_PROFILES_FAILURE
} from "./profileActions";

const initialState = {
  loading: false,
  profiles: [],
  error: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_PROFILES_SUCCESS:
      return {
        loading: false,
        profiles: action.payload,
        error: ""
      };
    case FETCH_PROFILES_FAILURE:
      return {
        loading: false,
        profiles: [],
        error: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
